import(/* webpackMode: "eager" */ "/workspace/src/app/sets/[id]/page.tsx");
